import React from 'react';
import { FormControl,Select,MenuItem,Card,CardContent } from '@material-ui/core'
import './App.css';
import axios from 'axios';
import InfoBox from './InfoBox'
import Map from './Map';
import Table from './Table'
import {sortData} from './utils';
import LineGraph from './LineGraph';
import "leaflet/dist/leaflet.css"


const App = (props) => {
  const [countries,setCountries] = React.useState()
  const [selectedCountry,setSelectedCountry] = React.useState("worldwide");
  const [countryInfo,setCountryInfo] = React.useState({});
  const [tableData,setTableData] = React.useState([]);
  const [mapCenter,setMapCenter] = React.useState({lat:28.3949,lng:84.1240});
  const [mapZoom,setMapZoom] = React.useState(3);
  const [mapCountries,setMapCountries] = React.useState([])
  const [casesType,setCasesType] = React.useState("cases")


  //api call
  React.useEffect(() => {
    axios.get('https://disease.sh/v3/covid-19/countries')
    .then(res => {
      
      let allcountries = res.data
      .map(country => (
        {
          name:country.country,
          value:country.countryInfo.iso2
        }
      ))
      let sortedData = sortData(res.data)
      
      setTableData(sortedData)
      setMapCountries(res.data)
      setCountries([...allcountries])
    })
    .catch(err => console.log(err));
  },[])

  React.useEffect(() => {
    axios.get('https://disease.sh/v3/covid-19/all')
    .then(res => {
      setCountryInfo(res.data)
    });
  },[])

  const onCountryChange = async (e) => {
    
    const url = e.target.value === 'worldwide' ? 'https://disease.sh/v3/covid-19/all' 
    : `https://disease.sh/v3/covid-19/countries/${e.target.value}`;

    try {
      let res = await axios.get(url);
      
      setSelectedCountry(e.target.value)
      setCountryInfo(res.data)
      if(res.data.countryInfo) {
        setMapCenter([res.data.countryInfo.lat,res.data.countryInfo.long])
        setMapZoom(4)
      }else {
        setMapCenter([41.8719,12.5674])
        setMapZoom(2)
      }
      
    }catch {
      console.log("Error")
    }
    
  }
  
  return (
  <div className="app">
    {/* app-left */}
    <div className="app__left">
          {/* header */}
        <div className="app_header">
            <h5>COVID 19 TRACKER</h5>
            
            <FormControl className="app__dropdown">
              <Select
                variant="outlined"
                value={selectedCountry}
                onChange={onCountryChange}
              >
                <MenuItem value="worldwide">Worldwide</MenuItem>
                {countries && countries.map((country,id) => {
                  return (<MenuItem key={id}   value={country.value}>{country.name}</MenuItem>)
                })}
              </Select>
            </FormControl>
        </div>

        {/* state */}
        <div className="app__stats">
                <InfoBox isRed active={casesType === "cases"}  clicked={() => setCasesType("cases")} title="Coronavirus cases" cases={countryInfo.todayCases || 0} total={countryInfo.cases || 0} />
                <InfoBox active={casesType === "recovered"}  clicked={() => setCasesType("recovered")} title="Recovered cases" cases={countryInfo.todayRecovered || 0} total={countryInfo.recovered} />
                <InfoBox isRed  active={casesType === "deaths"} clicked={() => setCasesType("deaths")} title="Deaths" cases={countryInfo.todayDeaths || 0} total={countryInfo.deaths || 0} />
        </div>

        {/* Map */}
        <Map casesType={casesType} countries={mapCountries} center={mapCenter} zoom={mapZoom} />
    </div>

    {/* app-right */}
    <Card className="app__right">
      <CardContent>
        <h5>Live cases by country</h5>
        <Table countries={tableData} />
        <h5>Worldwide new {casesType}</h5>
        <LineGraph casesType={casesType} />
      </CardContent>
          
    </Card>
    
  </div>
    )
}



export default App;